import { useMemo, useRef, useState } from "react";
import { ColDef, ColumnState, RowClickedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1071_R01HeaderDto } from "./PDA1071_R01Dto";
import {
  aggridHeaderClass,
  pdaCellStyle,
} from "src/components/common/common";

interface Props {
  workOrderList: PDA1071_R01HeaderDto[];
  onSelectWorkOrder: (order: PDA1071_R01HeaderDto) => void;
}

type RowType = PDA1071_R01HeaderDto & { inserted?: boolean };

const PDA1071_R01Table: React.FC<Props> = ({ workOrderList, onSelectWorkOrder }) => {
  const gridRef = useRef<AgGridReact<RowType>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [, setHoveredRowIndex] = useState<number | null>(null);
  const [, setColumnState] = useState<ColumnState[] | null>(null);

  const rowData = useMemo(() => [...workOrderList] as RowType[], [workOrderList]);

  const columnDefs = useMemo<ColDef<RowType>[]>(
    () => [
      {
        headerName: "일자",
        field: "workDt",
        valueGetter: (params) => {
          const dateStr = params.data?.workDt;
          if (!dateStr) return "-";
          const parts = String(dateStr).split("-");
          if (parts.length >= 3) return `${parts[1]}-${parts[2]}`;
          return dateStr;
        },
        cellStyle: {
          textAlign: "center",
          ...pdaCellStyle,
          justifyContent: "center",
        },
        headerClass: aggridHeaderClass,
        flex: 0.7,
        minWidth: 90,
      },
      {
        headerName: "코드",
        field: "productWorkNo",
        valueGetter: (params) => params.data?.productWorkNo ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 90,
      },
      {
        headerName: "품명",
        field: "itemNm",
        valueGetter: (params) => params.data?.itemNm ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 1.5,
        minWidth: 90,
      },
      {
        headerName: "규격",
        field: "itemSpec",
        valueGetter: (params) => params.data?.itemSpec ?? "-",
        cellStyle: {
          textAlign: "left",
          ...pdaCellStyle,
        },
        headerClass: aggridHeaderClass,
        flex: 2,
        minWidth: 80,
      },
    ] as ColDef<RowType>[],
    []
  );

  const onRowClicked = (e: RowClickedEvent<RowType>) => {
    if (e.data) onSelectWorkOrder(e.data);
  };

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={rowData}
        initSelected={() => {}}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1071_R01_List_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<RowType>
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1071_R01_List_ColumnState"
            setColumnState={setColumnState}
            onRowClicked={onRowClicked}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1071_R01Table;
